import React, {
    useState,
    useEffect,
    useRef,
    useCallback,
    useLayoutEffect,
} from 'react'
import { Okpd2 } from '../../../../../Org/Handbook/types'
import { OrganizationInfo } from '../../../../../Org/Home/types'

import { ContractPerformance, Country } from '../../../../types'
import { CurrencyList } from '../../../types'

import { Okei } from '../../../../../Plans/Positions/Edit/types'

import {
    PerformanceContractDocPositionItem,
    PerformanceContractDocPositionDraft,
} from '../../types'

import LoadingIcon from '../../../../../../../components/LoadingIcon'
import HoverTooltip from '../../../../../../../components/HoverTooltip'

import PerformanceDocsCountryOriginPopup from '../PerformanceDocsCountryOriginPopup'
import PerformanceDocsCountryManufacturerPopup from '../PerformanceDocsCountryManufacturerPopup'

import { NumericFormat } from 'react-number-format'

const formatNumber = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '-' // Обрабатываем пустые значения

    const parsedNum = typeof num === 'number' ? num : parseFloat(num)

    if (isNaN(parsedNum)) {
        return '-' // Обрабатываем некорректные значения
    }

    return parsedNum
        .toFixed(2) // Два знака после запятой
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // Разделяем тысячные пробелами
        .replace('.', ',') // Заменяем точку на запятую
}

const formatNumberDot = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '-' // Обрабатываем пустые значения

    const parsedNum = typeof num === 'number' ? num : parseFloat(num)

    if (isNaN(parsedNum)) {
        return '-' // Обрабатываем некорректные значения
    }

    return parsedNum
        .toFixed(2) // Два знака после запятой
        .replace(' ', '') // Разделяем тысячные пробелами
        .replace(',', '.') // Заменяем точку на запятую
}

type Props = {
    theme: string
    performanceContractDocPositionItem: PerformanceContractDocPositionItem
    exchangeRate: number | null
    currencyDigitalCode: number | null
    currencyList: CurrencyList[]
    selected: boolean
    onClick: (ordinal: number) => void
    onRightClick: (ordinal: number) => void
    onChangeQty: (v: string) => void
    onChangeUnitPrice: (v: string) => void
    onChangeTotalRub: (v: string) => void
    onChangeRubUnitPrice: (v: string) => void
    onUpdateItem: (
        ordinal: number,
        patch: Partial<
            PerformanceContractDocPositionDraft['performance_contract_doc_position_item'][number]
        >
    ) => void
    okeiList: Okei[]
}

const PerformanceDocsEditPopupTableRow: React.FC<Props> = (props) => {
    const textareaRef = useRef<HTMLTextAreaElement>(null)

    const [
        performanceDocsCountryOriginPopup,
        setPerformanceDocsCountryOriginPopup,
    ] = useState<boolean>(false)
    const [
        performanceDocsCountryManufacturerPopup,
        setPerformanceDocsCountryManufacturerPopup,
    ] = useState<boolean>(false)

    const [localValue, setLocalValue] = useState<string>(
        props.performanceContractDocPositionItem.qty
            ?.toString()
            .replace('.', ',') ?? ''
    )
    const debounceTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
        null
    )

    useLayoutEffect(() => {
        const el = textareaRef.current
        if (!el) return
        el.style.height = 'auto'
        // даем макету стабилизироваться
        requestAnimationFrame(() => {
            el.style.height = `${el.scrollHeight + 2}px`
        })
    }, [])

    const handlePerformanceDocsCountryOriginPopup = () => {
        setPerformanceDocsCountryOriginPopup(!performanceDocsCountryOriginPopup)
    }

    const handlePerformanceDocsCountryManufacturerPopup = () => {
        setPerformanceDocsCountryManufacturerPopup(
            !performanceDocsCountryManufacturerPopup
        )
    }

    return (
        <div className="flex flex-col w-full h-fit">
            {/* строка документа */}
            <div
                className={
                    'flex flex-row gap-1 mx-1 rounded text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#e4e6e8] dark:bg-[#242225] p-1 items-start justify-center'
                }
                // onClick={() => {
                //     props.onClick(
                //         props.performanceContractDocPositionItem
                //             .contract_position_guid
                //     )
                // }}
                onContextMenu={(e) => {
                    e.preventDefault() // Отключает стандартное контекстное меню
                    // props.onRightClick(
                    //     props.performanceContractDocPositionItem
                    //         .contract_position_guid
                    // )
                }}
                // onDoubleClick={() => props.onDoubleClick(props.performance.guid)}
            >
                <div
                    className="flex w-8 h-full items-start justify-center text-center cursor-pointer"
                    onClick={() => {
                        props.onClick(
                            props.performanceContractDocPositionItem.ordinal
                        )
                    }}
                >
                    <HoverTooltip tooltipText="Выбрать строку">
                        <input
                            type="checkbox"
                            className="flex h-[28px] cursor-pointer"
                            checked={props.selected}
                            onClick={(e) => e.stopPropagation()}
                            onChange={() => {
                                props.onClick(
                                    props.performanceContractDocPositionItem
                                        .ordinal
                                )
                            }}
                        />
                    </HoverTooltip>
                </div>
                <div
                    className="flex w-10 h-full pt-1 items-start justify-center text-[#6A6A6A] dark:text-[#8A8A8A] cursor-pointer"
                    onClick={() => {
                        props.onClick(
                            props.performanceContractDocPositionItem.ordinal
                        )
                    }}
                >
                    {props.performanceContractDocPositionItem.ordinal}
                </div>
                <div className="flex flex-1 items-center justify-start text-[#181818] dark:text-[#FFFFFF] ">
                    <HoverTooltip
                        tooltipContent={'Наименование товара, работы, услуги'}
                        align="right"
                        valign="bottom"
                    >
                        <textarea
                            ref={textareaRef}
                            className={`form-textarea-table-row flex min-h-[28px] w-full p-1 px-2 rounded-md text-[11px] text-[#181818] dark:text-[#FFFFFF] bg-[#181818]`}
                            maxLength={2000}
                            value={
                                props.performanceContractDocPositionItem
                                    .contract_position_name
                            }
                            rows={1}
                            readOnly
                        />
                    </HoverTooltip>
                </div>
                <div className="relative flex w-[165px] text-[#181818] dark:text-[#FFFFFF] items-center justify-end">
                    <HoverTooltip
                        tooltipContent={
                            props.performanceContractDocPositionItem
                                .contract_position_country_of_origin != null
                                ? props.performanceContractDocPositionItem.contract_position_country_of_origin.country.map(
                                      (c, index) => (
                                          <div key={index}>{c.name}</div>
                                      )
                                  )
                                : '-'
                        }
                        valign="bottom"
                    >
                        <input
                            type="text"
                            className="form-input-table-row flex pl-2 pr-9 w-full h-[28px] rounded-md text-[#181818] dark:text-[#FFFFFF] ..."
                            value={
                                props.performanceContractDocPositionItem
                                    .contract_position_country_of_origin
                                    ?.country[0].name
                            }
                            readOnly
                        />
                    </HoverTooltip>
                    <button
                        className="absolute flex w-6 h-6 mr-1 rounded-full items-center justify-center bg-[#FFFFFF] hover:bg-[#e4e6e8] dark:bg-[#181818] dark:hover:bg-[#656365]"
                        onClick={handlePerformanceDocsCountryOriginPopup}
                    >
                        {/* иконка */}
                        <svg
                            className="w-3 h-3"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            id="bars"
                        >
                            <path
                                fill={
                                    props.theme == 'dark'
                                        ? '#FFFFFF'
                                        : '#181818'
                                }
                                d="M3,8H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,8Zm18,8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-5H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
                            ></path>
                        </svg>
                    </button>
                    {props.performanceContractDocPositionItem
                        .contract_position_country_of_origin ? (
                        props.performanceContractDocPositionItem
                            .contract_position_country_of_origin.country
                            .length > 1 ? (
                            <div className="absolute right-[-4px] top-[-7px] flex w-4 h-4 items-center justify-center text-center rounded-full bg-[#494849]">
                                {
                                    props.performanceContractDocPositionItem
                                        .contract_position_country_of_origin
                                        .country.length
                                }
                            </div>
                        ) : (
                            ''
                        )
                    ) : (
                        ''
                    )}
                </div>
                <div className="relative flex w-[165px] text-[#181818] dark:text-[#FFFFFF] items-center justify-end">
                    <HoverTooltip
                        tooltipText={
                            props.performanceContractDocPositionItem
                                .contract_position_country_manufacturer != null
                                ? String(
                                      props.performanceContractDocPositionItem
                                          .contract_position_country_manufacturer
                                          .name
                                  )
                                : '-'
                        }
                        valign="bottom"
                    >
                        <input
                            type="text"
                            className="form-input-table-row flex pl-2 pr-9 w-full h-[28px] rounded-md text-[#181818] dark:text-[#FFFFFF] ..."
                            value={
                                props.performanceContractDocPositionItem
                                    .contract_position_country_manufacturer
                                    ?.name
                            }
                            readOnly
                        />
                    </HoverTooltip>
                    <button
                        className="absolute flex w-6 h-6 mr-1 rounded-full items-center justify-center bg-[#FFFFFF] hover:bg-[#e4e6e8] dark:bg-[#181818] dark:hover:bg-[#656365]"
                        onClick={handlePerformanceDocsCountryManufacturerPopup}
                    >
                        {/* иконка */}
                        <svg
                            className="w-3 h-3"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            id="bars"
                        >
                            <path
                                fill={
                                    props.theme == 'dark'
                                        ? '#FFFFFF'
                                        : '#181818'
                                }
                                d="M3,8H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,8Zm18,8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-5H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
                            ></path>
                        </svg>
                    </button>
                </div>
                <div className="flex w-32 items-center justify-center ">
                    <NumericFormat
                        value={props.performanceContractDocPositionItem.qty}
                        // важное:
                        decimalSeparator=","
                        thousandSeparator=" "
                        allowNegative={false}
                        allowLeadingZeros={false}
                        // максимум 4 знака после запятой
                        decimalScale={4}
                        // при пустом значении не принудительно не добиваем нули
                        fixedDecimalScale={false}
                        // это заставит onValueChange.value быть С ТОЧКОЙ (канонично для бэка)
                        valueIsNumericString
                        // ввод из буфера с запятой/точкой работает:
                        onValueChange={(v) => {
                            // v.value — строка с ТОЧКОЙ без пробелов (например "1234.5")
                            // v.floatValue — число (может быть undefined при пустом инпуте)
                            // Если бэку нужен Decimal-строка с точкой:
                            const dotString = v.value ?? ''
                            props.onChangeQty(dotString === '' ? '' : dotString) // либо Number(dotString) если нужен number
                        }}
                        // не даём вводить ничего кроме цифр, точки, запятой
                        isAllowed={(vals) => {
                            // react-number-format сам ограничит по decimalScale,
                            // но добавим запрет на NaN
                            if (vals.formattedValue === '') return true
                            return !Number.isNaN(vals.floatValue)
                        }}
                        className="form-input-table-row rounded-md text-primary text-center w-full h-[28px] px-2"
                        // Запрет стандартной прокрутки значения колесом
                    />
                </div>
                <div className="flex w-32 items-center justify-center ">
                    <HoverTooltip
                        tooltipText={
                            props.performanceContractDocPositionItem
                                .okei_code == null
                                ? 'Выбрать'
                                : String(
                                      props.performanceContractDocPositionItem
                                          .okei_name
                                  )
                        }
                    >
                        <select
                            className="form-input-table-row px-2 rounded-md w-full h-[28px]"
                            value={
                                props.performanceContractDocPositionItem
                                    .okei_code != null
                                    ? props.performanceContractDocPositionItem
                                          .okei_code
                                    : ''
                            }
                            onChange={(e) => {
                                const selectedCode = e.target.value
                                const selectedOkei = props.okeiList.find(
                                    (okei) => okei.code === selectedCode
                                )
                                const okei_code = selectedOkei?.code
                                const okei_name = selectedOkei?.name
                                props.onUpdateItem(
                                    props.performanceContractDocPositionItem
                                        .ordinal,
                                    { okei_code }
                                )
                                props.onUpdateItem(
                                    props.performanceContractDocPositionItem
                                        .ordinal,
                                    { okei_name }
                                )
                            }}
                        >
                            <option
                                className="text-[#6A6A6A] dark:text-[#8A8A8A]"
                                value=""
                            >
                                {props.performanceContractDocPositionItem
                                    .okei_code == null
                                    ? 'Выбрать'
                                    : ''}
                            </option>
                            {props.okeiList.map((item, index) => (
                                <option key={index} value={item.code}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </HoverTooltip>
                </div>
                <div className="flex flex-col gap-3 w-32 items-center justify-center ">
                    <NumericFormat
                        value={
                            props.performanceContractDocPositionItem.unit_price
                        }
                        className={`form-input-table-row rounded-md text-primary w-full h-[28px] px-2 text-right`}
                        allowNegative={false}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        decimalSeparator=","
                        thousandSeparator=" "
                        placeholder="0,00"
                        disabled={false}
                        onValueChange={(v) => {
                            // v.value — строка с ТОЧКОЙ без пробелов (например "1234.5")
                            // v.floatValue — число (может быть undefined при пустом инпуте)
                            // Если бэку нужен Decimal-строка с точкой:
                            const dotString = v.value ?? ''
                            props.onChangeUnitPrice(
                                dotString === '' ? '' : dotString
                            ) // либо Number(dotString) если нужен number
                        }}
                    />
                    {props.currencyDigitalCode != 643 && (
                        <div className="flex flex-col gap-1 w-full items-center justify-center h-fit">
                            <div className="flex flex-col w-full">
                                <label className="w-full text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    Цена за единицу (руб.)
                                </label>
                                <NumericFormat
                                    value={
                                        Number(
                                            props
                                                .performanceContractDocPositionItem
                                                .unit_price
                                        ) * Number(props.exchangeRate)
                                    }
                                    className={`form-input-table-row rounded-md text-primary w-full h-[28px] px-2 text-right`}
                                    allowNegative={false}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    decimalSeparator=","
                                    thousandSeparator=" "
                                    placeholder="0,00"
                                    disabled={true}
                                    onValueChange={(v) => {
                                        // v.value — строка с ТОЧКОЙ без пробелов (например "1234.5")
                                        // v.floatValue — число (может быть undefined при пустом инпуте)
                                        // Если бэку нужен Decimal-строка с точкой:
                                        const dotString = v.value ?? ''
                                        props.onChangeRubUnitPrice(
                                            dotString === '' ? '' : dotString
                                        ) // либо Number(dotString) если нужен number
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex flex-col gap-3 w-32 items-center justify-center ">
                    <NumericFormat
                        value={
                            Number(
                                props.performanceContractDocPositionItem.qty
                            ) *
                            Number(
                                props.performanceContractDocPositionItem
                                    .unit_price
                            )
                        }
                        className={`form-input-table-row rounded-md text-primary w-full h-[28px] px-2 text-right`}
                        allowNegative={false}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        decimalSeparator=","
                        thousandSeparator=" "
                        placeholder="0,00"
                        disabled={true}
                        onValueChange={(v) => {
                            // v.value — строка с ТОЧКОЙ без пробелов (например "1234.5")
                            // v.floatValue — число (может быть undefined при пустом инпуте)
                            // Если бэку нужен Decimal-строка с точкой:
                            const dotString = v.value ?? ''
                            props.onChangeTotalRub(
                                dotString === '' ? '' : dotString
                            ) // либо Number(dotString) если нужен number
                        }}
                    />
                    {props.currencyDigitalCode != 643 && (
                        <div className="flex flex-col gap-1 w-full items-center justify-center h-fit">
                            <div className="flex flex-col w-full">
                                <label className="w-full text-[10px] text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    Сумма по позиции (руб.)
                                </label>
                                <NumericFormat
                                    value={
                                        Number(
                                            props
                                                .performanceContractDocPositionItem
                                                .qty
                                        ) *
                                        Number(
                                            props
                                                .performanceContractDocPositionItem
                                                .unit_price
                                        ) *
                                        Number(props.exchangeRate)
                                    }
                                    className={`form-input-table-row rounded-md text-primary w-full h-[28px] px-2 text-right`}
                                    allowNegative={false}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                    decimalSeparator=","
                                    thousandSeparator=" "
                                    placeholder="0,00"
                                    disabled={true}
                                    onValueChange={(v) => {
                                        // v.value — строка с ТОЧКОЙ без пробелов (например "1234.5")
                                        // v.floatValue — число (может быть undefined при пустом инпуте)
                                        // Если бэку нужен Decimal-строка с точкой:
                                        const dotString = v.value ?? ''
                                        props.onChangeTotalRub(
                                            dotString === '' ? '' : dotString
                                        ) // либо Number(dotString) если нужен number
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {performanceDocsCountryOriginPopup && (
                <PerformanceDocsCountryOriginPopup
                    theme={props.theme}
                    performanceContractPositionGuid={
                        props.performanceContractDocPositionItem
                            .contract_position_guid
                    }
                    performanceContractDocPositionItem={
                        props.performanceContractDocPositionItem
                    }
                    handlePerformanceDocsCountryOriginPopup={
                        handlePerformanceDocsCountryOriginPopup
                    }
                    onUpdateItem={props.onUpdateItem}
                />
            )}
            {performanceDocsCountryManufacturerPopup && (
                <PerformanceDocsCountryManufacturerPopup
                    theme={props.theme}
                    performanceContractPositionGuid={
                        props.performanceContractDocPositionItem
                            .contract_position_guid
                    }
                    performanceContractDocPositionItem={
                        props.performanceContractDocPositionItem
                    }
                    handlePerformanceDocsCountryManufacturerPopup={
                        handlePerformanceDocsCountryManufacturerPopup
                    }
                    onUpdateItem={props.onUpdateItem}
                />
            )}
        </div>
    )
}

export default PerformanceDocsEditPopupTableRow
